export default {
    data() {
        return {
            pressingTypes: [
                { text: 'Country', value: 'country' },
                { text: 'Edition', value: 'edition' },
                { text: 'Fidelity', value: 'fidelity' },
                { text: 'Release Date', value: 'release' },
                { text: 'Plant', value: 'plant' },
                { text: 'Variation', value: 'variation' },
            ]
        }
    }
}